// API Configuration
// En dev usa localhost:3001 (seteado en .env.local). En prod usa URL relativa (mismo servidor).
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// API Base URL configurado

